// filter.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'countryFilter' })
export class CountryFilterPipe implements PipeTransform {
  /**
   *
   * @param list
   * @param searchText 搜索国家名或区号
   * @returns
   */
  transform(list: any[], searchText: any): any[] {
    const normalizedSearchText = String(searchText ?? '')
      .trim()
      .toLowerCase();
    const len = normalizedSearchText.length;

    return list.find(item => item.name.substr(0, len).toLowerCase().includes(normalizedSearchText))
      ? list.filter(item => item.name.substr(0, len).toLowerCase().includes(normalizedSearchText))
      : list.filter(item => item.areaCode.substr(0, len + 1).includes(String(searchText ?? '').trim()));
  }
}
